export default {
  "Loop as a GIF": "Schleife als GIF",
  "without sound": "Kein Ton",
  "Final output duration": "Endgültige Exportlänge",
};
